import { Outlet } from "react-router-dom";

export default function ProductsLayout() {
  return <Outlet />;
}
